import React, { FC } from 'react';

import { formatter } from 'helpers';
import { useLang } from 'hooks';
import { CardView } from 'components/layout';
import { Balance } from 'types/models';

import styles from './styles.module.css';

type WithdrawalBalanceProps = {
  balance: Balance;
};

const WithdrawalBalance: FC<WithdrawalBalanceProps> = ({ balance }) => {
  const lang = useLang();

  return (
    <CardView
      captionClassName={styles.balance__caption}
      title={lang.get('withdrawal.balance.title')}
      caption={formatter.formatCurrency(balance.balance, balance.currency)}
    />
  );
};

export default WithdrawalBalance;
